import { useEffect } from "react";

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  ogImageWidth?: string;
  ogImageHeight?: string;
  jsonLd?: Record<string, unknown>;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogType = "website", ogImage, ogImageWidth, ogImageHeight, jsonLd }: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", ogType, true);
    setMeta("og:url", canonicalUrl, true);
    setMeta("og:site_name", "韩漫之家", true);
    setMeta("og:locale", "zh_CN", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);

    if (ogImage) {
      setMeta("og:image", ogImage, true);
      setMeta("twitter:image", ogImage);
      if (ogImageWidth) setMeta("og:image:width", ogImageWidth, true);
      if (ogImageHeight) setMeta("og:image:height", ogImageHeight, true);
    }

    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    let jsonLdEl = document.querySelector('script[type="application/ld+json"][data-seo="dynamic"]');
    if (jsonLdEl) jsonLdEl.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "dynamic");
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, ogImageWidth, ogImageHeight, jsonLd]);

  return null;
}